import {Base} from 'src/models/base';

export class NoteTemplate extends Base {
  static table = 'note_templates';

  static associations = {
    note_template_versions: {type: 'has_many', key: 'note_template_id'},
  };
}
